import { identity } from "@vueuse/core";

// TODO: previous regex was  " /\p{L}|\p{N}|['’\-–—]/u "
// should we actually match numbers and apostrophes?

// unicode  Regex are saved in their string form to prevent SyntaxError on browsers that do not support some features
const WordRegexes: { r: string; f: string; disabled?: boolean }[] = [
  // Unicode property escapes (with 'v' flag) - best but not supported everywhere
  { r: "\\p{L}|-", f: "v", disabled: true }, // we don't YET? need the `v` flag variant
  // Unicode property escapes (with 'u' flag) - good but not supported everywhere
  { r: "\\p{L}|-", f: "u" },
  // Fallback - basic latin letters and numbers only
  { r: "[a-z-]", f: "i" },
];

const wordCharRegex: RegExp = WordRegexes.map((wr) => {
  try {
    if (wr.disabled) return null;
    return new RegExp(wr.r, wr.f);
  } catch (e) {
    return null;
  }
}).filter(identity)[0];

export function isWordChar(char: string): boolean {
  return wordCharRegex.test(char);
}

// uses in-source tests to tests each specific regexes
if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest;

  describe("WordRegexes", () => {
    it("should all compile without error", () => {
      WordRegexes.forEach((wr) => new RegExp(wr.r, wr.f));
    });

    it("should have 3 declinations", () => {
      expect(WordRegexes.length).toBe(3);
    });

    function hyphenMatches(regex: RegExp) {
      it("matches hyphen", () => {
        expect(regex.test("-")).toBe(true);
      });
    }

    function basicAsciiMatches(regex: RegExp) {
      it("matches ascii latin letters", () => {
        expect(regex.test("a")).toBe(true);
        expect(regex.test("Z")).toBe(true);
      });
    }

    function basicUnicodeMatches(regex: RegExp) {
      it("matches accented latin letters", () => {
        expect(regex.test("é")).toBe(true);
        expect(regex.test("ç")).toBe(true);
        expect(regex.test("à")).toBe(true);
        expect(regex.test("ô")).toBe(true);
        expect(regex.test("ñ")).toBe(true);
      });

      it("matches ligatures", () => {
        expect(regex.test("æ")).toBe(true);
        expect(regex.test("œ")).toBe(true);
      });
    }

    function basicNonMatches(regex: RegExp) {
      it("does not match punctuation", () => {
        expect(regex.test(".")).toBe(false);
        expect(regex.test(",")).toBe(false);
        expect(regex.test("!")).toBe(false);
        expect(regex.test("?")).toBe(false);
        expect(regex.test(";")).toBe(false);
        expect(regex.test(":")).toBe(false);
      });
    }

    describe("Best (unicodeSets)", () => {
      const regex = new RegExp(WordRegexes[0].r, WordRegexes[0].f);
      it("uses the `v` flag", () => expect(regex.flags).toContain("v"));

      hyphenMatches(regex);
      basicAsciiMatches(regex);
      basicUnicodeMatches(regex);
      basicNonMatches(regex);
      // TODO: is there any use cases that needs the 'v' flag?
    });

    describe("Good (unicode)", () => {
      const regex = new RegExp(WordRegexes[1].r, WordRegexes[1].f);
      it("uses the `u` flag", () => expect(regex.flags).toContain("u"));

      hyphenMatches(regex);
      basicAsciiMatches(regex);
      basicUnicodeMatches(regex);
      basicNonMatches(regex);
    });

    describe("Fallback (latin)", () => {
      const regex = new RegExp(WordRegexes[2].r, WordRegexes[2].f);
      it("does not use any special flag", () =>
        expect(regex.flags).not.toMatch(/[uv]/));

      hyphenMatches(regex);
      basicAsciiMatches(regex);
      basicNonMatches(regex);
    });
  });
}
